import ApiService from "@/common/api.service";
import { COMPANY_ID } from "@/common/config.js";

import {
  GET_PRODUCT_OPTION1,
  GET_PRODUCT_OPTION2,
  GET_CATEGORY_PRODUCT,
  GET_CATEGORY_LIST
} from "./actions.type";
import {
  SET_PRODUCT_OPTION1,
  SET_PRODUCT_OPTION2,
  SET_CATEGORY_PRODUCT,
  SET_CATEGORY_LIST,
  SET_CATEGORY_PRODUCT_LIST
} from "./mutations.type";

const state = {
  errors: null,
  categoryList: null,
  productOption1: null,
  productOption2: null,
  products: [],
  categoryProductList: null,
  relateds: [
    {
      id: 1,
      link: "#",
      img: require("@/assets/img/common/dammy06.jpg"),
      name: "こってりラーメン",
      combo: "6食"
    },
    {
      id: 2,
      link: "#",
      img: require("@/assets/img/common/dammy06.jpg"),
      name: "こってりラーメン",
      combo: "6食"
    },
    {
      id: 3,
      link: "#",
      img: require("@/assets/img/common/dammy06.jpg"),
      name: "こってりラーメン",
      combo: "6食"
    },
    {
      id: 4,
      link: "#",
      img: require("@/assets/img/common/dammy06.jpg"),
      name: "こってりラーメン",
      combo: "6食"
    },
    {
      id: 5,
      link: "#",
      img: require("@/assets/img/common/dammy06.jpg"),
      name: "こってりラーメン",
      combo: "6食"
    },
    {
      id: 6,
      link: "#",
      img: require("@/assets/img/common/dammy06.jpg"),
      name: "こってりラーメン",
      combo: "6食"
    }
  ],
  movies: [
    {
      id: 1,
      src: "https://www.youtube.com/embed/Vb8UK71XnJk",
      title: "YouTube video player"
    }
  ]
};
const getters = {
  productOption1(state) {
    return state.productOption1;
  },
  productOption2(state) {
    return state.productOption2;
  },
  productCategory(state) {
    return state.products;
  },
  relateds(state) {
    return state.relateds;
  },
  movies(state) {
    return state.movies;
  },
  categoryList(state) {
    return state.categoryList;
  },
  categoryProductList(state) {
    return state.categoryProductList;
  }
};

const actions = {
  [GET_PRODUCT_OPTION1]({ commit }) {
    ApiService.get(
      "v1/products",
      `public_categories?limit=10&offset=0&name=チャーシュー・メンマ&company_id=${COMPANY_ID}`
    )
      .then((data) => {
        ApiService.get(
          "/v1/products/with_category",
          `${data.data[0].category_id}?limit=10&offset=0`
        ).then((response) => {
          commit(SET_PRODUCT_OPTION1, response.data);
        });
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error(error);
      });
  },
  [GET_PRODUCT_OPTION2]({ commit }) {
    ApiService.get(
      "v1/products",
      `public_categories?limit=10&offset=0&name=ラーメン鉢&company_id=${COMPANY_ID}`
    )
      .then((data) => {
        ApiService.get(
          "v1/products/with_category",
          `${data.data[0].category_id}?limit=10&offset=0`
        ).then((response) => {
          commit(SET_PRODUCT_OPTION2, response.data);
        });
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error(error);
      });
  },
  [GET_CATEGORY_PRODUCT]({ commit }, id) {
    return ApiService.get(
      "v1/products/with_category",
      `${id}?limit=10&offset=0`
    )
      .then((response) => {
        commit(SET_CATEGORY_PRODUCT, response.data);
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error(error);
      });
  },
  [GET_CATEGORY_LIST]({ commit }, payload) {
    ApiService.get(
      "v1/products",
      `public_categories?limit=${payload.limit}&offset=${payload.offset}&name=${payload.name}&company_id=${COMPANY_ID}`
    ).then(({ data }) => {
      if (data.length > 0) {
        commit(SET_CATEGORY_LIST, data[0].child_categories);
        commit(SET_CATEGORY_PRODUCT_LIST, data[0].products);
      }
    });
  }
};

const mutations = {
  [SET_PRODUCT_OPTION1](state, payload) {
    state.productOption1 = payload;
  },
  [SET_PRODUCT_OPTION2](state, payload) {
    state.productOption2 = payload;
  },
  [SET_CATEGORY_PRODUCT](state, payload) {
    state.products = payload;
  },
  [SET_CATEGORY_LIST](state, payload) {
    state.categoryList = payload;
  },
  [SET_CATEGORY_PRODUCT_LIST](state, payload) {
    state.categoryProductList = payload;
  }

};

export default {
  state,
  actions,
  mutations,
  getters
};
